var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import cn from 'classnames';
import deprecated from 'react-prop-types/lib/deprecated';
import getField from '../utils/getField';
import themeColors from '../utils/themeColors';
import getCollapserStyles from '../utils/getCollapserStyles';
import controlled from '../utils/PropTypes/controlled';
import Paper from '../Papers/Paper';
import AccessibleFakeButton from '../Helpers/AccessibleFakeButton';
import Collapse from '../Helpers/Collapse';
import FontIcon from '../FontIcons/FontIcon';
import getDeprecatedIcon from '../FontIcons/getDeprecatedIcon';
import PanelContent from './PanelContent';
var LABEL_FONT_SIZE = 15;
var LINE_HEIGHT = 1.42857;
var SINGLE_LINE_HEIGHT = LABEL_FONT_SIZE * LINE_HEIGHT;

/**
 * The `ExpansionPanel` component needs to be used with the `ExpansionList`
 * component. The only reason is that the `ExpansionPanel` should really
 * be rendered as a table, but it was a bit hard to have a single component
 * dynamically rendering another row when expanded. It couldn't be in the
 * same row since the expanded content might not have the same columns.
 */

var ExpansionPanel = function (_PureComponent) {
  _inherits(ExpansionPanel, _PureComponent);
  function ExpansionPanel(props, context) {
    _classCallCheck(this, ExpansionPanel);
    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props, context));
    _this._determineIfTwoLine = function () {
      var twoLine = false;
      Array.prototype.slice.call(findDOMNode(_this).querySelectorAll('.md-panel-column')).some(function (el) {
        return twoLine = el.offsetHeight > SINGLE_LINE_HEIGHT;
      });
      _this.setState({
        twoLine: twoLine
      });
    };
    _this._handleClick = function () {
      var expanded = !_this._isExpanded(_this.props, _this.state);
      if (_this.props.onExpandToggle) {
        _this.props.onExpandToggle(expanded);
      }
      if (typeof _this.props.expanded === 'undefined') {
        _this.setState({
          expanded: expanded
        });
      }
    };
    _this._handleSave = function (e) {
      var _this$props = _this.props,
        onSave = _this$props.onSave,
        onExpandToggle = _this$props.onExpandToggle,
        closeOnSave = _this$props.closeOnSave;
      if (onSave) {
        onSave(e);
      }
      if (closeOnSave) {
        if (onExpandToggle) {
          onExpandToggle(false);
        }
        if (typeof _this.props.expanded === 'undefined') {
          _this.setState({
            expanded: false
          });
        }
      }
    };
    _this._handleCancel = function (e) {
      var _this$props2 = _this.props,
        onCancel = _this$props2.onCancel,
        onExpandToggle = _this$props2.onExpandToggle,
        closeOnCancel = _this$props2.closeOnCancel;
      if (onCancel) {
        onCancel(e);
      }
      if (closeOnCancel) {
        if (onExpandToggle) {
          onExpandToggle(false);
        }
        if (typeof _this.props.expanded === 'undefined') {
          _this.setState({
            expanded: false
          });
        }
      }
    };
    _this.state = {
      received: false,
      twoLine: false
    };
    if (typeof props.expanded === 'undefined') {
      _this.state.expanded = props.defaultExpanded;
    }
    return _this;
  }
  ExpansionPanel.prototype.componentDidMount = function componentDidMount() {
    this._determineIfTwoLine();
  };
  ExpansionPanel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (process.env.NODE_ENV === 'development' && !this.state.received) {
      if (nextProps.columnWidths.length === 0) {
        // Hopefully a nice warning about fixing the missing props injected from ExpansionList
        /* eslint-disable no-console */
        console.error('The `ExpansionPanel` component expects the `columnWidths` prop to be injected from the ' + '`ExpansionList` component. It could be missing because:' + '\n - you have a wrapper component with extra functionality' + '\n - the `ExpansionPanel` is not a direct child of the `ExpansionList` component' + '\n\nYou can fix this by making sure to pass `this.props.focused` and `this.props.columnWidths` ' + 'within your wrapper component and making the `ExpansionPanel` a direct child of `ExpansionList`.');
      }
      this.setState({
        received: true
      });
    }
  };
  ExpansionPanel.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.label === prevProps.label && this.props.secondaryLabel === prevProps.secondaryLabel) {
      return;
    }
    this._determineIfTwoLine();
  };
  ExpansionPanel.prototype._isExpanded = function _isExpanded(props, state) {
    return typeof props.expanded === 'undefined' ? state.expanded : props.expanded;
  };
  ExpansionPanel.prototype.render = function render() {
    var _props = this.props,
      className = _props.className,
      label = _props.label,
      secondaryLabel = _props.secondaryLabel,
      expandedSecondaryLabel = _props.expandedSecondaryLabel,
      children = _props.children,
      focused = _props.focused,
      columnWidths = _props.columnWidths,
      saveType = _props.saveType,
      saveLabel = _props.saveLabel,
      savePrimary = _props.savePrimary,
      saveSecondary = _props.saveSecondary,
      saveProps = _props.saveProps,
      cancelType = _props.cancelType,
      cancelLabel = _props.cancelLabel,
      cancelPrimary = _props.cancelPrimary,
      cancelSecondary = _props.cancelSecondary,
      cancelProps = _props.cancelProps,
      headerStyle = _props.headerStyle,
      headerClassName = _props.headerClassName,
      contentStyle = _props.contentStyle,
      contentClassName = _props.contentClassName,
      tabIndex = _props.tabIndex,
      overflown = _props.overflown,
      footer = _props.footer,
      footerChildren = _props.footerChildren,
      footerStyle = _props.footerStyle,
      footerClassName = _props.footerClassName,
      expandIconChildren = _props.expandIconChildren,
      expandIconClassName = _props.expandIconClassName,
      propAnimateContent = _props.animateContent,
      propExpanded = _props.expanded,
      propExpanderIcon = _props.expanderIcon,
      defaultExpanded = _props.defaultExpanded,
      closeOnSave = _props.closeOnSave,
      closeOnCancel = _props.closeOnCancel,
      onSave = _props.onSave,
      onCancel = _props.onCancel,
      onExpandToggle = _props.onExpandToggle,
      props = _objectWithoutProperties(_props, ['className', 'label', 'secondaryLabel', 'expandedSecondaryLabel', 'children', 'focused', 'columnWidths', 'saveType', 'saveLabel', 'savePrimary', 'saveSecondary', 'saveProps', 'cancelType', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'headerStyle', 'headerClassName', 'contentStyle', 'contentClassName', 'tabIndex', 'overflown', 'footer', 'footerChildren', 'footerStyle', 'footerClassName', 'expandIconChildren', 'expandIconClassName', 'animateContent', 'expanded', 'expanderIcon', 'defaultExpanded', 'closeOnSave', 'closeOnCancel', 'onSave', 'onCancel', 'onExpandToggle']);
    var twoLine = this.state.twoLine;
    var expanded = this._isExpanded(this.props, this.state);
    var animateContent = getField(this.props, this.context, 'animateContent');
    var columns = Children.map(expanded && expandedSecondaryLabel || secondaryLabel, function (panelLabel, i) {
      var _ref;
      return React.createElement('div', {
        style: (_ref = {}, _ref['' + (overflown ? 'width' : 'minWidth')] = columnWidths[i + 1], _ref),
        className: cn('md-panel-column', {
          'md-panel-column--overflown': overflown
        }, themeColors({
          text: true
        }))
      }, panelLabel);
    });
    if (!Array.isArray(columns)) {
      columns = [columns];
    }
    columns.unshift(React.createElement('div', {
      key: 'main-label',
      style: {
        minWidth: columnWidths[0]
      },
      className: cn('md-panel-column', themeColors({
        text: true
      }))
    }, label));
    var expanderIcon = getDeprecatedIcon(expandIconClassName, expandIconChildren, this.props.expanderIcon);
    expanderIcon = React.Children.only(expanderIcon);
    expanderIcon = React.cloneElement(expanderIcon, {
      className: getCollapserStyles({
        flipped: expanded
      }, 'md-expansion-panel__collapser md-cell--right', expanderIcon.props.className)
    });
    return React.createElement(Paper, _extends({}, props, {
      className: cn('md-expansion-panel', {
        'md-expansion-panel--expanded': expanded
      }, className),
      'aria-expanded': expanded
    }), React.createElement(AccessibleFakeButton, {
      onClick: this._handleClick,
      style: headerStyle,
      className: cn('md-panel-header', {
        'md-panel-header--expanded': expanded || twoLine,
        'md-panel-header--focused': focused
      }, headerClassName),
      tabIndex: tabIndex
    }, columns, expanderIcon), React.createElement(Collapse, {
      collapsed: !expanded,
      animate: animateContent
    }, React.createElement(PanelContent, {
      style: contentStyle,
      className: contentClassName,
      footerStyle: footerStyle,
      footerClassName: footerClassName,
      onSave: this._handleSave,
      onCancel: this._handleCancel,
      saveType: saveType,
      saveLabel: saveLabel,
      savePrimary: savePrimary,
      saveSecondary: saveSecondary,
      saveProps: saveProps,
      cancelType: cancelType,
      cancelLabel: cancelLabel,
      cancelPrimary: cancelPrimary,
      cancelSecondary: cancelSecondary,
      cancelProps: cancelProps,
      footer: footer,
      footerChildren: footerChildren
    }, children)));
  };
  return ExpansionPanel;
}(PureComponent);
ExpansionPanel.propTypes = {
  /**
   * An optional style to apply to the panel.
   */
  style: PropTypes.object,
  /**
   * An optional className to apply to the panel.
   */
  className: PropTypes.string,
  /**
   * An options style to apply to the panel's header content. This is the
   * section that toggles the children to be visible and label columns.
   */
  headerStyle: PropTypes.object,
  /**
   * An optional className to apply to the panel's header content. This is the
   * section that toggles the children to be visible and label columns.
   */
  headerClassName: PropTypes.string,
  /**
   * An optional style to apply to the element surrounding the children when expanded.
   */
  contentStyle: PropTypes.object,
  /**
   * An optional className to apply to the element surrounding the children when expanded.
   */
  contentClassName: PropTypes.string,
  /**
   * An optional style to apply to the footer when the `footer` prop is `undefined`.
   *
   * @see {@link #footer}
   */
  footerStyle: PropTypes.object,
  /**
   * An optional className to apply to the footer when the `footer` prop is `undefined`.
   *
   * @see {@link #footer}
   */
  footerClassName: PropTypes.string,
  /**
   * The main label to display in the unexpanded panel.
   */
  label: PropTypes.node.isRequired,
  /**
   * Any additional columns to display after the main label. If this is a `list`
   * instead of a singular item, they will each be formatted as a column.
   */
  secondaryLabel: PropTypes.node,
  /**
   * Any additional columns to display after the main label when the panel is
   * expanded. If this is omitted, the default `secondaryLabel` will be displayed
   * instead.
   */
  expandedSecondaryLabel: PropTypes.node,
  /**
   * The component to render the panel as.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The content to display once the panel is toggled open.
   */
  children: PropTypes.node,
  /**
   * A boolean if the panel is currently expanded. This will force the component
   * to be controlled and require's the `onExpandToggle` function to be defined.
   */
  expanded: controlled(PropTypes.bool, 'onExpandToggle', 'defaultExpanded'),
  /**
   * Boolean if an uncontrolled panel should be expanded by default.
   */
  defaultExpanded: PropTypes.bool.isRequired,
  /**
   * The icon to display for expanding the expansion panel.
   */
  expanderIcon: PropTypes.element,
  /**
   * Boolean if the `ExpansionPanel` is currently tab focused. This is injected
   * and managed by the `ExpansionList` component. Do not set yourself.
   */
  focused: PropTypes.bool.isRequired,
  /**
   * A list of min-widths to apply to each column in the panel header. This is injected
   * and managed by the `ExpansionList` component. Do not set yourself.
   */
  columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * Boolean if the panel has too much content so that it overflowns. This is injected
   * and managed by the `ExpansionList` component. Do not set yourself.
   *
   * When this is active, it will truncate all columns except for the main label and the
   * toggle icon.
   */
  overflown: PropTypes.bool,
  /**
   * A function to call when the expansion panel's expanded state is toggled.
   * The callback for this function will include the new expanded state.
   *
   * `onExpandToggle(expanded)`
   */
  onExpandToggle: PropTypes.func,
  /**
   * An optional function to call when the Save button is clicked on the expanded panel.
   */
  onSave: PropTypes.func,
  /**
   * An optional function to call when the Cancel button is clicked on the expanded panel.
   */
  onCancel: PropTypes.func,
  /**
   * Boolean if the panel should close when the Save button is clicked.
   */
  closeOnSave: PropTypes.bool,
  /**
   * Boolean if the panel should close when the Cancel button is clicked.
   */
  closeOnCancel: PropTypes.bool,
  /**
   * An optional button type to apply to the Save button. This will get
   * passed to the `FlatButton`.
   */
  saveType: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
   * The label for the Save button.
   */
  saveLabel: PropTypes.node.isRequired,
  /**
   * Boolean if the Save button should be styled with the primary color.
   */
  savePrimary: PropTypes.bool,
  /**
   * Boolean if the Save button should be styled with the secondary color,
   */
  saveSecondary: PropTypes.bool,
  /**
   * Any additional props to provide/override for the save button in the
   * footer of the panel.
   */
  saveProps: PropTypes.object,
  /**
   * An optional button type to apply to the Cancel button. This will get
   * passed to the `FlatButton`.
   */
  cancelType: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
   * The label for the Cancel button.
   */
  cancelLabel: PropTypes.node.isRequired,
  /**
   * Boolean if the Cancel button should be styled with the primary color,
   */
  cancelPrimary: PropTypes.bool,
  /**
   * Boolean if the Cancel button should be styled with the secondary color,
   */
  cancelSecondary: PropTypes.bool,
  /**
   * Any additional props to provide/override for the cancel button in the
   * footer of the panel.
   */
  cancelProps: PropTypes.object,
  /**
   * The tab index for the panel's header. This allows keyboard navigation.
   */
  tabIndex: PropTypes.number.isRequired,
  /**
   * Boolean if the panel's content should animate when the content's visibility changes. This
   * can also be toggled from the `ExpansionList` component if all `ExpansionPanel` in the list
   * should not animate. This only affects the height transition.
   *
   * > The default value is really `true` since it gets passed down to the `Collapse` component.
   */
  animateContent: PropTypes.bool,
  /**
   * This prop controls the footer for the expansion panel. If this prop is `undefined`, it will
   * go with the default behavior of generating the save and cancel buttons with the save and cancel
   * props.
   *
   * If this value is `null`, there will be no footer created.
   *
   * Finally, if this prop is defined as any renderable item, it will be displayed in place of the
   * footer.
   *
   * @see {@link #footerChildren}
   */
  footer: PropTypes.node,
  /**
   * Any additional children that should be displayed in the footer of the panel. These children
   * will be placed after the action buttons.
   */
  footerChildren: PropTypes.node,
  expandIconChildren: deprecated(PropTypes.node, 'Use the `expanderIcon` instead'),
  expandIconClassName: deprecated(PropTypes.string, 'Use the `expanderIcon` instead')
};
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  expanderIcon: React.createElement(FontIcon, null, 'keyboard_arrow_down'),
  component: 'li',
  saveLabel: 'Save',
  cancelLabel: 'Cancel',
  savePrimary: true,
  tabIndex: 0,
  closeOnSave: true,
  closeOnCancel: true,
  focused: false,
  columnWidths: []
};
ExpansionPanel.contextTypes = {
  animateContent: PropTypes.bool
};
export default ExpansionPanel;